class BESSAppMenuToggleComponent extends BESSAppComponent {

    constructor() {
        super('.app-menu-toggle');
    }

    setupComponent(node) {
        this.onSelected(node, function () {
            $('body').removeClass('sidebar-hide');
            let main = $('.main');
            let sidebar = $('.sidebar');
            sidebar.addClass('animate');
            main.addClass('animate');
            $('body').addClass('menu-open').append("<div class='overlay'></div>");

            $('.overlay').bindClickEvent(this.#closeMenu);

            setTimeout(function () {
                sidebar.removeClass('animate');
                main.removeClass('animate');
            }.bind(this), 500);

        });

        this.onSelected($('.sidebar .close-menu'), this.#closeMenu);

        $(window).resize(function () {
            if ($(window).width() >= 992) {
                if ($('.menu-open').length > 0) {
                    this.#closeMenu();
                }
            }
        }.bind(this));
    }

    #closeMenu() {
        let main = $('.main');
        let sidebar = $('.sidebar');
        sidebar.addClass('animate');
        main.addClass('animate');
        $('body').removeClass('menu-open')

        setTimeout(function () {
            sidebar.removeClass('animate');
            main.removeClass('animate');
            $('.overlay').remove();
        }.bind(this), 500);
    }
}